import React from 'react';
import { Alert, Box, Paper, Typography } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { WideLayout } from '../../../shared/layout/widelayout';
import { usePortalStore } from '../../../stores/portalStore';
import { canAccessPatientsV2 } from '../usecases/v2/types';

const AccessDenied = () => (
  <Box sx={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
    <Paper sx={{ maxWidth: 560, width: '100%', p: 3 }}>
      <Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
        Gestão de Pacientes
      </Typography>
      <Alert severity="warning">Acesso Premium necessário para visualizar a Gestão de Pacientes.</Alert>
    </Paper>
  </Box>
);

export const PatientV2AccessRoute = () => {
  const currentUser = usePortalStore((state: any) => state.currentUser);

  if (!canAccessPatientsV2(currentUser)) {
    return <WideLayout outlet={<AccessDenied />} />;
  }

  return <Outlet />;
};
